export default __webpack_public_path__ + "a39876ecad3ec411333bb16981ec1455.png";